import {IHttpResponse, IHttpService, IPromise} from "angular";
import {ToastNotificationServiceName} from "../../utils/names/serviceNames";
import {ToastNotificationService} from "../../utils/ToastNotificationService";
import {Opportunity} from "../../opportunities/model/Opportunity";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {ActionTypes} from "../../action_status/model/ActionType";

export class OpportunityPreRenderService {

    static instance = [
        '$http',
        ToastNotificationServiceName,
        OpportunityPreRenderService
    ]

    constructor(private $http: IHttpService,
                private toastNotificationService: ToastNotificationService) {
    }

    getOpportunityPreRender(opportunity: Opportunity, actionType: ActionTypes): IPromise<string> {
        return this.$http({
            method: 'GET',
            url: this.getOpportunityPreRenderUrl(opportunity, actionType)
        }).then((resp: IHttpResponse<string>) => {
            if (resp.status == 200) {
                return resp.data;
            } else {
                this.toastNotificationService.generateErrorMessage('Failed to fetch preview');
                throw new Error();
            }
        })
    }

    getOpportunityPreRenderUrl(opportunity: Opportunity, actionType: ActionTypes): string {
        return getAbsoluteUrl(`api/opportunity/${opportunity.id}/help/${actionType}`);
    }
}